import { BaseResponse, TableList } from '@/types/common';
import axiosInstance from './axiosInstance';

const baseUrl = `${SUPP_ADMIN_BASE_URL}/supp-management`;

export enum ActivityPublishStatus {
  CANCELED = -1,
  PENDING = 0,
  PUBLISHED = 1,
  RECALLED = 2,
}

export interface ActivityNotificationTestParams {
  imageUrl: string;
  ratio: number;
  title: string;
  link: string;
  email: string;
  notifyType: ActivityNotifyType;
}

/**
 * 活动通知测试.
 *
 * @param params 测试参数.
 * @returns 测试结果.
 */
export const activityNotificationTest = async (
  params: ActivityNotificationTestParams
) => {
  const resp = await axiosInstance.post<BaseResponse<void>>(
    `${baseUrl}/activity/notification/test`,
    params
  );
  return resp.data;
};

export enum ActivityNotifyType {
  LINK = 1, // 链接
  TAG = 2, // 标签
  ARTWORK = 3, // 作品
  BROWSER = 4, // 浏览器
  CONTEST = 5, // contest ID
  NEWCOMER_CONTEST = 6, // 新人王链接跳转
}

export interface ActivityNotificationSaveOrUpdateParams {
  activityNotificationId?: number;
  imageUrl: string;
  ratio: number;
  title: string;
  notifyType: ActivityNotifyType;
  link: string;
  publishTime: string;
  pushTargetType: number;
}

/**
 * 保存或更新活动通知.
 *
 * @param params 保存或更新参数.
 * @returns 保存或更新结果.
 */
export const activityNotificationSaveOrUpdate = async (
  params: ActivityNotificationSaveOrUpdateParams
) => {
  const resp = await axiosInstance.post<BaseResponse<void>>(
    `${baseUrl}/activity/notification/saveOrUpdate`,
    params
  );
  return resp.data;
};

export interface ActivityNotificationListParams {
  publishStatus?: ActivityPublishStatus;
  currentPage: number;
  pageSize: number;
}

export interface ActivityNotification {
  activityNotificationId: number;
  imageUrl: string;
  ratio: number;
  title: string;
  link: string;
  notifyType: ActivityNotifyType;
  publishTime: string;
  publishStatus: ActivityPublishStatus;
  publishUser: string;
  createTime: string;
  pushTargetType?: number;
}

/**
 * 活动通知列表.
 *
 * @param params 列表参数.
 * @returns 列表结果.
 */
export const activityNotificationList = async (
  params: ActivityNotificationListParams
) => {
  const resp = await axiosInstance.post<
    BaseResponse<TableList<ActivityNotification>>
  >(`${baseUrl}/activity/notification/list`, params);
  return resp.data;
};

/**
 * 活动通知详情.
 *
 * @param id 活动通知ID.
 * @returns 详情结果.
 */
export const activityNotificationDetail = async (id: string) => {
  const resp = await axiosInstance.get<BaseResponse<ActivityNotification>>(
    `${baseUrl}/activity/notification/detail`,
    {
      params: {
        activityNotificationId: id,
      },
    }
  );
  return resp.data;
};

/**
 * 取消活动通知.
 *
 * @param id 活动通知ID.
 * @returns 取消结果.
 */
export const activityNotificationCancel = async (id: number) => {
  const resp = await axiosInstance.post<BaseResponse<void>>(
    `${baseUrl}/activity/notification/cancel`,
    [id] // 注意：这里是数组格式，后面支持批量时需要调整入参
  );
  return resp.data;
};

/**
 * 撤回.
 *
 * @param id 活动通知ID.
 * @returns 取消结果.
 */
export const activityNotificationRecall = async (id: number) => {
  const resp = await axiosInstance.get<BaseResponse<void>>(
    `${baseUrl}/activity/notification/recall`,
    {
      params: {
        activityNotificationId: id,
      },
    }
  );
  return resp.data;
};
